import React from 'react';

import { Grid, Typography } from '@material-ui/core';
import { Row } from '../../Resources';
import ActivitiesRegistrationHeader from 'components/ActivitiesRegistrationDetails/ActivitiesRegistrationHeader';

export default function VehicleExit({ activityData, lastRegister }) {
  return(
    <Grid container>
      <Grid xs={12}>
        <ActivitiesRegistrationHeader
          activityData={activityData}
        />
      </Grid>
      <Grid xs={12}>
        <div style={{ border: '1px solid #D7D7D7', borderRadius: 5, backgroundColor: '#FCFCFC', padding: 8, marginTop: 10 }}>
          <Row>
            <Typography color='primary'>
              <b>OSs abertas</b>
            </Typography>
            <div>
              {lastRegister?.openedIds?.length == 0 && (
                <Typography color='textSecondary'>
                  --
                </Typography>
              )}
              {lastRegister?.openedIds?.length > 0 && lastRegister?.openedIds?.map(id => {
                return(
                  <Typography color='textSecondary'>
                    {id}
                  </Typography>
                );
              })}
            </div>
          </Row>
          <Row marginTop={10}>
            <Typography color='primary'>
              <b>OSs fechadas</b>
            </Typography>
            <div>
              {lastRegister?.closedIds?.length == 0 && (
                <Typography color='textSecondary'>
                  --
                </Typography>
              )}
              {lastRegister?.closedIds?.length > 0 && lastRegister?.closedIds?.map(id => {
                return(
                  <Typography color='textSecondary'>
                    {id}
                  </Typography>
                );
              })}
            </div>
          </Row>
        </div>
      </Grid>
    </Grid>
  );
}